import isEmpty from 'lodash.isempty';

const fullname = function(provider) {
	let fullName = `${provider.name_last}, ${provider.name_first}`;
	if (!isEmpty(provider.name_middle)) {
		fullName = `${fullName} ${provider.name_middle}`;
	}
	if (!isEmpty(provider.credentials)) {
		fullName = `${fullName} ${provider.credentials}`;
	}
	return fullName;
};

export {
	fullname
};
